import type { FC } from 'react';
import AntAlert from 'antd/es/alert';
import type { AlertProps as AntAlertProps } from 'antd/es/alert';
import { cn } from 'app/lib/utils';

export interface AlertProps extends AntAlertProps {}

/**
 * Banner façade over antd `Alert`.
 */
export const Alert: FC<AlertProps> = ({ className, ...rest }) => (
  <AntAlert className={cn(className)} {...rest} />
);

export default Alert;
